import { memo } from 'react';
import moment from 'moment';
import { DateInfoWrapper } from '../meter.styled';
import { Text, HStack } from 'app/pages/request-single-page/components-v4';
import { useResponsive } from 'app/hooks';
import { getPassedDaysStr } from 'app/pages/request-single-page/utils';

type MeterDateInfoProps = {
  title: string;
  date: moment.Moment | null;
  isOverdue: boolean;
  emptyText?: string;
};

export const MeterDateInfo = memo(
  ({ title, date, isOverdue, emptyText }: MeterDateInfoProps) => {
    const { viewport } = useResponsive();
    const now = moment();

    return (
      <DateInfoWrapper>
        <Text
          variant={viewport.mobile ? 'heading-5' : 'heading-4'}
          color="gray.500"
        >
          {title}
        </Text>

        {date ? (
          <HStack align="center" justify="space-between">
            <Text variant={viewport.mobile ? 'body-14' : 'body-16'}>
              {date.format('L')}
            </Text>
            <Text
              variant={viewport.mobile ? 'body-14' : 'body-16'}
              color={isOverdue ? 'red.500' : 'gray.500'}
            >
              {getPassedDaysStr(now, date, {
                compact: viewport.mobile,
              })}
            </Text>
          </HStack>
        ) : (
          <Text
            variant={viewport.mobile ? 'body-14' : 'body-16'}
            color="gray.400"
          >
            {emptyText}
          </Text>
        )}
      </DateInfoWrapper>
    );
  }
);
